<template>
  <div class="performanceBox">
    <div class="performanceMain">
      <breadcrumb>
        <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/personal/sign/home' }">签约管理</el-breadcrumb-item>
          <el-breadcrumb-item
            :to="{ path: `/personal/sign/selectCertificate?id=${this.$route.query.id}` }"
          >查看证书</el-breadcrumb-item>
          <el-breadcrumb-item>合同详细凭证</el-breadcrumb-item>
        </el-breadcrumb>
      </breadcrumb>
      <div class="performanceConFinsh">
        <div class="performanceTurn">
          <h5>基本信息</h5>
          <div style="overflow:hidden" v-if="detail">
            <el-form class="first">
              <el-form-item label="合同名称：">{{detail.info.name}}</el-form-item>
              <el-form-item label="发起签约时间：">{{detail.info.signStartTime}}</el-form-item>
              <el-form-item label="签署方式：">
                <span v-if="detail.info.orderType == 0">无序</span>
                <span v-if="detail.info.orderType == 1">顺序</span>
              </el-form-item>
              <el-form-item label="发起方：">{{detail.contractUser.name}}</el-form-item>
            </el-form>
            <el-form>
              <el-form-item label="合同编号：">{{detail.info.code}}</el-form-item>
              <el-form-item label="签署完成时间：">{{detail.info.signFinishTime}}</el-form-item>
              <el-form-item label="签署截止日期：">{{detail.info.signDeadlineDate.slice(0,10)}}</el-form-item>
              <el-form-item
                label="合同有效期限："
              >{{detail.info.startDate.slice(0,10)}}至{{detail.info.endDate.slice(0,10)}}</el-form-item>
            </el-form>
            <el-form>
              <el-form-item label="证书签发机构：">司法联盟链legalXchain</el-form-item>
              <el-form-item label="签署平台：">广州公证处区块链赋强公证系统</el-form-item>
              <el-form-item label="时间戳：">国家授时中心北斗卫星授时</el-form-item>
              <el-form-item label="签署地点：">北京</el-form-item>
            </el-form>
            <el-form class="el-last-form">
              <el-form-item label="签署方：">
                <span
                  class="moreNameSign"
                  v-for="(item,index) in detail.signatoryList"
                  :key="index"
                >{{item.name}}&nbsp;&nbsp;</span>
              </el-form-item>
            </el-form>
          </div>
          <div class="blockId">
            <p class="ft12">
              区块链记录ID：
              <span>{{detail.info.txId}}</span>
            </p>
          </div>
        </div>
        <div class="performanceTurn">
          <h5>保全凭证</h5>
          <div class="voucher" v-if="detail">
            <div v-for="item in detail.contractSignList" class="module" :key="item.signStatusTime">
              <div class="titleDscp">
                <div class="status">{{judgeStatus(item)}}</div>
                <!-- <div class="time">{{item.signStatusTime |formatData}}</div>
                <div class="time">{{item.signStatusTime |formatDataLast}}</div>-->
              </div>
              <div class="contentDscp">
                <div class="saved" v-if="item.signStatus !== 1"></div>
                <ul>
                  <li class="item">
                    <span class="label">{{judgePerson(item)}}:</span>
                    <span class="content">{{item.signUser.name}}</span>
                  </li>
                  <li class="item">
                    <span class="label">{{judgeTime(item)}}:</span>
                    <span class="content">{{item.signStatusTime}}</span>
                  </li>
                  <li class="item">
                    <span class="label">存证ID：</span>
                    <span class="content">{{item.txId}}</span>
                  </li>
                </ul>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Dialog from "@common/Dialog.vue";
import PageSize from "@common/PageSize.vue";
import BaseApi from "@lib/baseApi.js";
import Breadcrumb from "../../../components/common/Breadcrumb.vue";
import {mapState} from "vuex"
export default {
  components: { Breadcrumb, Dialog },
  data() {
    return {
      detail: null
    };
  },
  computed:{
    ...mapState(["curState"])
  },
  created() {
    this.init();
  },
  mounted() {},
  filters: {
    formatData(value) {
      if (value) {
        return value.slice(0, 10);
      } else {
        return "";
      }
    },
    formatDataLast(value) {
      if (value) {
        return value.slice(10);
      } else {
        return "";
      }
    }
  },
  methods: {
    init() {
      BaseApi.createRpcToken("/contract/detail", {
        id: this.$route.query.id || "b70a942ada294030b8037ed556f57dd1"
      })
        .then(
          data => {
            this.detail = data.datas.detail;
          },
          () => {}
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    judgeStatus(item) {
      if (item.signStatus === 0) {
        return "发起签约";
      } else if (item.signStatus === 2) {
        return "已签";
      } else if (item.signStatus === 1) {
        return "未签";
      } else if (item.signStatus === 3) {
        return "拒签";
      }
    },
    judgePerson(item) {
      if (item.signStatus === 0) {
        return "发起方";
      } else {
        return "签约方";
      }
    },
    judgeTime(item) {
      if (item.signStatus === 0) {
        return "发起时间";
      } else {
        return "签署时间";
      }
    }
  },
  watch:{
    "curState"(data){
      this.$router.replace("/personal/home")
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.signDetailDialogWithButton {
  height: 200px;
  width: 400px;
  box-sizing: border-box;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 0 20px;
  .authDscp {
    font-size: 14px;
    color: #646464;
    letter-spacing: 0;
    text-align: center;
    line-height: 20px;
    padding-top: 20px;
  }
  .withInput {
    width: 100%;
    text-align: left;
    .el-input__inner {
      width: 100%;
      height: 32px;
      line-height: 32px;
    }
  }
}

.performanceBox {
  background: #eaedf1;
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  .performanceMain {
    width: 100%;
    position: relative;
    height: 100%;
    display: table;
    background: #fff;
    border-radius: 3px;
    padding: 20px;
    box-sizing: border-box;
    .performanHead {
      width: 100%;
      height: 36px;
      padding: 8px 0;
      box-sizing: border-box;
      box-shadow: inset 0 -1px 0 0 rgba(230, 230, 230, 0.5);
      li {
        float: left;
      }
      li:nth-child(1) {
        display: block;
        width: 4px;
        height: 20px;
        background: #e88078;
        margin-right: 20px;
        border-radius: 4px;
      }
      li:nth-child(2) {
        // color:#787878;
        font-family: "PingFangSC-Medium";
      }
      li:last-child {
        color: #e88078;
      }
    }
    .performanceCon {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      height: calc(100% - 36px);
      .el-form {
        width: 400px;
        height: 540px;
        .el-form-item {
          width: 100%;
        }
        .el-form-item__label {
          line-height: 36px;
          font-size: 14px;
          color: #282828;
          width: 106px;
          padding: 0;
        }
        .el-form-item__label:before {
          content: "*";
          color: #f56c6c;
          margin-right: 4px;
          vertical-align: middle;
        }
        .el-form-item__content {
          line-height: 36px;
          float: left;
          .el-input__inner {
            width: 290px;
            padding-left: 10px;
            height: 36px;
            line-height: 36px;
            border-radius: 0;
          }
        }
        .el-range-separator {
          line-height: 28px;
        }
        .explainBox {
          height: 78px;
          .el-textarea__inner {
            width: 290px;
            height: 78px;
            resize: none;
          }
        }
        .el-form-item:nth-child(7),
        .el-form-item:nth-child(8) {
          .el-form-item__label:before {
            content: "";
          }
        }
        .el-button--primary {
          width: 120px;
          height: 36px;
          line-height: 36px;
          border: 1px solid #db4437;
          font-size: 14px;
          color: #db4437;
          padding: 0;
          background-color: #fff;
          margin-left: 106px;
        }
        .period {
          position: relative;
          .termination {
            position: absolute;
            right: -90px;
            top: 0;
          }
        }
      }
    }
    .performanceConFinsh {
      width: 100%;
      margin-top: 20px;
      height: calc(100% - 58px);
      overflow-y: auto;
      overflow-x: hidden;
      .performanceConHead {
        width: 100%;
        text-align: right;
        margin-bottom: 16px;
        span {
          display: inline-block;
          height: 32px;
          line-height: 32px;
          border: 1px solid #e88078;
          font-size: 14px;
          color: #e88078;
          text-align: center;
          margin-left: 10px;
          img {
            vertical-align: middle;
            margin-right: 4px;
          }
        }
        span:nth-child(1),
        span:nth-child(2) {
          width: 180px;
        }
        span:nth-child(3) {
          width: 100px;
        }
      }
      .performancebody {
        width: 100%;
        height: 394px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        border: 1px solid #e4e8eb;
        .setPre {
          background: #ffffff;
          border: 1px solid #e88078;
          border-radius: 5px;
          font-size: 14px;
          color: #e88078;
          text-align: center;
          line-height: 32px;
          width: 280px;
          cursor: pointer;
        }
        .resetSign {
          width: 100px;
          height: 32px;
          line-height: 32px;
          cursor: pointer;
          font-size: 12px;
          color: #db4437;
          text-align: center;
          border: 1px solid #db4437;
          margin-top: 16px;
        }
        .blockLine {
          height: 52px;
          line-height: 52px;
          padding: 0 20px;
          margin: 30px auto;
          background: #fafafa;
        }
        img {
          margin-bottom: 12px;
        }
        p {
          color: #505050;
        }
        p:last-child {
          margin-top: 30px;
          text-align: center;
          width: 563px;
          background: #f5f5f5;
          color: #969696;
        }
      }
      .performanceTurn {
        width: 100%;
        border: 1px solid #e4e8eb;
        border-radius: 0 0 3px 3px;
        height: auto;
        position: relative;
        margin-bottom: 20px;
        h5 {
          background: #f5f5f5;
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          color: #323232;
          text-indent: 10px;
        }
        .blockId {
          line-height: 52px;
          font-size: 12px;
          color: #969696;
          border-top: 1px dashed #e4e8eb;
          padding-left: 16px;
        }
        .el-form {
          float: left;
          width: calc(100% / 3);
          box-sizing: border-box;
          padding-top: 23px;
          .el-form-item {
            margin: 0;
            .el-form-item__label {
              width: 110px;
              line-height: 23px;
              font-size: 12px;
              color: #787878;
            }
            .el-form-item__content {
              line-height: 23px;
              font-size: 12px;
              color: #969696;
            }
          }
        }
        .el-last-form {
          width: 100%;
          padding-top: 0;
          padding-left: 10px;
          box-sizing: border-box;
          .el-form-item__label {
            width: 120px;
          }
        }
        .first {
          padding-left: 10px;
        }
        p {
          text-indent: 10px;
          font-size: 12px;
          color: #969696;
          span {
            display: inline-block;
            width: 98px;
            font-size: 12px;
            color: #787878;
            text-align: right;
          }
        }
        .save {
          position: absolute;
          right: 226px;
          bottom: 25px;
          width: 129px;
          height: 106px;
        }
      }
      .voucher {
        box-sizing: border-box;
        padding: 20px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        .module {
          display: flex;
          height: 125px;
          background: #ffffff;
          border: 1px dashed #c8c8c8;
          padding: 20px;
          box-sizing: border-box;
          border-radius: 6px;
          margin-right: 40px;
          margin-bottom: 20px;
          .titleDscp {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 114px;
            text-align: center;
            border-right: 1px solid #dcdcdc;
            .status {
              font-size: 18px;
              color: #646464;
            }
            .time {
              line-height: 20px;
              font-size: 12px;
              color: #505050;
            }
          }
          .contentDscp {
            padding-left: 30px;
            width: 418px;
            position: relative;
            .saved {
              position: absolute;
              width: 110px;
              height: 85px;
              top: 0;
              right: 0;
              background: url(./../../../assets/images/personalSignDetail/savedline.png);
              background-size: 110px 85px;
            }
            .item {
              display: flex;
              font-size: 14px;
              line-height: 24px;
            }
            .label {
              width: 108px;
              display: block;
              color: #787878;
            }
            .content {
              display: block;
              width: 303px;
              word-break: break-all;
              color: #969696;
            }
          }
        }
      }
    }
  }
}
</style>
